import { Component, OnInit } from "@angular/core";
import { ProductService } from "src/app/core/services/product.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-categories",
  templateUrl: "./categories.component.html",
  styleUrls: ["./categories.component.css"],
})
export class CategoriesComponent implements OnInit {
  categories: [];
  public urlHost = "";
  public loading:boolean=true;
  constructor(private productService: ProductService) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    this.loading=true;
    this.productService.getCategories().subscribe(
      (data) => {
        this.categories = data;
        this.loading=false;
      },
      (error) => {
        this.loading=false;
        console.log(error);
      }
    );
  }
}
